/*
  Calling supabase edge functions (for AI) requires using a custom and authenticated window.fetch.
  We grab the auth token from the extension, and make a customFetch function that's authed.
  */

import type { AuthToken } from '@annote/core/dbs/types';

export interface TokenProvider {
  getAuthToken(): Promise<AuthToken>;
}

// Internal token cache using WeakMap for automatic cleanup
const tokenCache = new WeakMap<TokenProvider, AuthToken>();

// Simple authenticated fetch that handles token caching internally
export const performAuthenticatedFetch = async (
  tokenProvider: TokenProvider,
  input: RequestInfo,
  init?: RequestInit,
): Promise<Response> => {
  // Get cached token or fetch a new one
  let currentToken = tokenCache.get(tokenProvider);
  console.log('performAuthenticatedFetch - currentToken', currentToken);
  if (!currentToken) {
    currentToken = await tokenProvider.getAuthToken();
    tokenCache.set(tokenProvider, currentToken);
  }

  // Check if token is expired (with 5 minute buffer)
  const now = Date.now() / 1000;
  const expiresAt = currentToken.expiresAt || 0;

  if (expiresAt - 300 < now) {
    // 5 minute buffer - refresh token
    currentToken = await tokenProvider.getAuthToken();
    tokenCache.set(tokenProvider, currentToken);
  }

  const headers = new Headers(init?.headers);
  headers.set('Authorization', `Bearer ${currentToken.token}`);

  return fetch(input, {
    ...init,
    headers,
  });
};
